export default __webpack_public_path__ + "static/media/six-highlights-bg.67ca3bcd.png";